<template>
  <div class="d-flex w-100">
    <div v-if="!details" class="d-flex w-100">
      <div class="col-md-3">
        <filterRegister :tipoFluxo="TipoQmaTemplate" @search="search"></filterRegister>
      </div>
      <div class="col-md-9">
        <collapseQma ref="collap" :tipoFluxo="TipoQmaTemplate"></collapseQma>
      </div>
    </div>
  </div>
</template>

<script>
import registersbasicQMAPIT from './registersbasicQMAPIT'
export default registersbasicQMAPIT

</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/registerbasicQMA/registerbasicQmaPIT/registerbasicQmaPIT.vue